import Vue from 'vue';
import store from '@/store';
//防抖节流
const on = Vue.prototype.$on;
Vue.prototype.$on = function (event, func) {
  let timer;
  let flag = true;
  let newFunc = func;
  if (event == 'click') {
    newFunc = function () {
      if (flag) {
        func.apply(this, arguments);
        flag = false;
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        flag = true;
      }, 200);
    };
  }
  on.call(this, event, newFunc);
};
const sysTemFilterWords = [
  // {
  //   word: 'insert',
  //   replacement: ''
  // },
  // {
  //   word: 'update',
  //   replacement: ''
  // },
  // {
  //   word: 'delete',
  //   replacement: ''
  // },
  // {
  //   word: '<',
  //   replacement: ''
  // },
  // {
  //   word: '>',
  //   replacement: ''
  // },
  // {
  //   word: '../',
  //   replacement: ''
  // },
  // {
  //   word: 'script',
  //   replacement: ''
  // },
  // {
  //   word: 'alert',
  //   replacement: ''
  // }
];

//敏感词自定义指令
Vue.directive('sensitive-words', {
  inserted: (el) => {
    let isOnComposition = false; //是否正在输入中文
    // 监听输入事件
    el.addEventListener('input', (event) => {
      //如果正在输入中文，就不做任何处理 等输入结束再处理
      if (isOnComposition) {
        return;
      }
      dispatch('input', event);
    });
    el.addEventListener('change', (event) => {
      dispatch('change', event);
    });
    el.addEventListener('compositionstart', () => {
      isOnComposition = true; //输入中文开始
    });
    el.addEventListener('compositionend', (event) => {
      isOnComposition = false; //输入中文结束
      dispatch('input', event);
    });
  },
  unbind: (el) => {
    el.removeEventListener('input', (event) => {
      console.log(event);
    });
  }
});

export const dispatch = (type, event) => {
  let inputValue = event.target.value;
  const replacements = store.state.app.sensitiveWords.concat(sysTemFilterWords);
  inputValue = replaceKeywords(inputValue, replacements);
  event.target.value = inputValue;
  event.target.dispatchEvent(new Event(type));

  //是中文输入结束 解决中文输入拼音的时候不更新和替换完长度超限问题
  const maxLength = event.target.maxLength;
  let inputValueNew = event.target.value;

  if (maxLength > 0 && inputValueNew.length > maxLength) {
    inputValueNew = inputValueNew.substring(0, maxLength);
    event.target.value = inputValueNew;
    event.target.dispatchEvent(new Event(type));
  }
};

export const replaceKeywords = (text, replacements) => {
  // 遍历关键词替换数组
  for (let i = 0; i < replacements.length; i++) {
    const { word, replacement } = replacements[i];
    // 使用正则表达式替换关键词
    const reg = /\.\.\//;
    if (word === '../') {
      text = text.replace(reg, replacement);
    } else {
      text = text.replace(new RegExp(word, 'g'), replacement);
    }
  }
  //如果替换之后的结果又变成了包含敏感词
  const containsSensitiveWords = replacements.some((item) =>
    text.includes(item.word)
  );

  if (containsSensitiveWords) {
    text = replaceKeywords(text, replacements);
  }

  return text;
};

//防连点指令
Vue.directive('throttle', {
  inserted: function (el, binding) {
    let timer;
    let flag = true;
    const delay = binding.value || 500;
    el.addEventListener('click', function (event) {
      if (flag) {
        flag = false;
        clearTimeout(timer);
        timer = setTimeout(function () {
          flag = true;
        }, delay);
      } else {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
});

//按钮权限自定义指令
export const checkUserPermission = (permission) => {
  return store.state.app.permissionCodes.includes(permission);
};
Vue.directive('has-btn-permission', {
  inserted: function (el, binding) {

    // 获取绑定的权限值
    let permission = binding.value;
    if (binding.arg === 'speakerNoSales') {
      // 使用正则表达式匹配倒数第二个下划线及其之前的部分，并替换为加上nosales_的版本
      permission = permission.replace(/([^_]+)_([^_]+)$/, '$1_nosales_$2');
    }
    // 检查用户是否拥有权限
    const isAllowed = checkUserPermission(permission); // 假设这是一个检查权限的函数

    if (!isAllowed) {
      // 如果用户不拥有权限，隐藏按钮
      el.parentNode.removeChild(el);
    }
  }
});
